import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	toolbarName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	toolbarName: {
		id: 'floating-toolbar.common.toolbar-name',
		defaultMessage: 'Bulk actions',
		description: 'The text will show when the toolbar is focused',
	},
});
